import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { CTABand } from "../components/CTABand";
import { Reveal } from "../components/Reveal";
import { IconCheck, IconArrow } from "../components/Icons";
import { getComplianceItem, getCompliance, mediaUrl } from "../lib/api";
import NotFound from "./NotFound";

export default function ComplianceDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [others, setOthers] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true); setError(false);
    getComplianceItem(slug).then(setItem).catch(() => setError(true)).finally(() => setLoading(false));
    getCompliance().then(setOthers).catch(() => {});
  }, [slug]);

  if (error) return <NotFound />;
  if (loading || !item) return <div style={{ minHeight: "60vh" }} />;

  return (
    <div data-testid="compliance-detail-page">
      <PageHeader eyebrow={`${item.tag} compliance`} title={item.title} lead={item.hero_lead} crumb={item.title}
        image={mediaUrl(item.image_media_id)} imageAlt={item.image_alt} />

      <section className="detail-section bg-paper" data-testid="compliance-overview">
        <div className="wrap detail-grid">
          <Reveal className="d-lead">
            <span className="eyebrow">Overview</span>
            <h2>{item.summary}</h2>
            {item.overview?.map((p, i) => <p key={i}>{p}</p>)}
            <div style={{ marginTop: 24, display: "flex", gap: 12, flexWrap: "wrap" }}>
              <Link to="/contact?intent=consultation" className="btn btn-primary" data-testid="compliance-cta">Request a Consultation</Link>
            </div>
          </Reveal>

          <Reveal delay={80}>
            <aside className="side-card">
              <h4>Other compliance services</h4>
              <p>Explore the full range of Lemur Quality compliance practices.</p>
              <ul className="side-links">
                {others.filter((o) => o.slug !== slug).map((o) => (
                  <li key={o.id}>
                    <Link to={`/compliance/${o.slug}`} data-testid={`compliance-related-${o.slug}`}>
                      {o.title} <IconArrow />
                    </Link>
                  </li>
                ))}
              </ul>
              <div style={{ marginTop: 22 }}>
                <Link to="/compliance" className="btn btn-ghost" style={{ width: "100%" }}>All compliance services</Link>
              </div>
            </aside>
          </Reveal>
        </div>
      </section>

      <section className="detail-section bg-mist" data-testid="compliance-items">
        <div className="wrap">
          <Reveal className="d-lead"><span className="eyebrow">What we deliver</span><h2>Scope of support</h2></Reveal>
          <div className="info-grid-2" style={{ marginTop: 30 }}>
            {item.items?.map((it, i) => (
              <Reveal key={i} className="mini-card" delay={(i % 2) * 60} data-testid="compliance-scope-item">
                <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                  <IconCheck stroke="#e11d3c" style={{ width: 20, height: 20, flex: "none", marginTop: 3 }} />
                  <div>
                    <h3 style={{ marginBottom: 6 }}>{it.title}</h3>
                    <p>{it.description}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
